// Calculator action row: Save / Print / Download PDF / Share buttons.
// Lives in the LEFT (form) column on every calculator page so all four buttons
// fit on a single line — the right column (ResultSheet) was too narrow and the
// Share button kept wrapping to a second row.
import { useNavigate } from 'react-router-dom'
import { localizedHref } from '../i18n/locale'
import type { Locale } from '../i18n/locale'
import { t } from '../i18n/strings'
import ShareButton from './ShareButton'

interface Props {
  locale: Locale
  /** Omit to hide the Save button (used by Dimensions Converter, which doesn't save). */
  onSave?: () => void | Promise<void>
  saved?: boolean
  className?: string
}

export default function CalcActions({ locale, onSave, saved, className }: Props) {
  const navigate = useNavigate()
  return (
    <div className={`flex flex-wrap items-center gap-2 ${className ?? ''}`}>
      {onSave && (
        <button
          type="button"
          // Persist the sheet, then take the user straight to My Sheets so they
          // see it land — saving with no visible result felt like nothing happened.
          onClick={async () => { await onSave(); navigate(localizedHref('/my-sheets/', locale)) }}
          className="rounded-md bg-primary px-4 py-2 text-sm font-semibold text-on-primary hover:opacity-90"
        >
          {saved ? t(locale, 'result.saved') : t(locale, 'result.save')}
        </button>
      )}
      <button
        type="button"
        onClick={() => window.print()}
        className="rounded-md border border-border bg-surface px-4 py-2 text-sm font-medium text-text-body hover:bg-surface-2"
      >
        {t(locale, 'result.print')}
      </button>
      <button
        type="button"
        onClick={() => window.print()}
        className="rounded-md border border-border bg-surface px-4 py-2 text-sm font-medium text-text-body hover:bg-surface-2"
      >
        {t(locale, 'result.downloadPdf')}
      </button>
      <ShareButton locale={locale} />
    </div>
  )
}
